export default __webpack_public_path__ + "static/media/Rectangle547.4defa48a.png";